import {INIT_NAVIGATION} from "./js/inits/init.navigation";
import {SET_FOOTER_HEIGHT} from "./js/helpers/footer-height";


document.documentElement.classList.replace('no-js', 'js-rules');
INIT_NAVIGATION();
SET_FOOTER_HEIGHT();


window.addEventListener('resize', () => {
  SET_FOOTER_HEIGHT();
});


function checkForGlobalMessageMarquee() {
  const HEADER_GLOBAL_MESSAGE_ELEMENT = document.querySelectorAll('.global-message');

  HEADER_GLOBAL_MESSAGE_ELEMENT.forEach(globalMessageElement => {
    const LINK_ELEMENT = globalMessageElement.querySelector('.global-message-link') || false
    const CONTENT_ELEMENT = globalMessageElement.querySelector('.inner:not([aria-hidden])') || false;

    if (!LINK_ELEMENT || !CONTENT_ELEMENT) return;

    const LINK_WIDTH = LINK_ELEMENT.getBoundingClientRect().width - 10;
    const CONTENT_WIDTH = CONTENT_ELEMENT.getBoundingClientRect().width;

    const SPEED = 200;
    const DURATION = CONTENT_WIDTH / SPEED;

    globalMessageElement.style.setProperty('--animation-duration', `${DURATION}s`);

    if (CONTENT_WIDTH > LINK_WIDTH) globalMessageElement.classList.add('is--marquee');
    else globalMessageElement.classList.remove('is--marquee');

  })
}

document.addEventListener('DOMContentLoaded', () => {

  checkForGlobalMessageMarquee();

});

window.addEventListener('resize', checkForGlobalMessageMarquee);
